module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-3-1.bb49f6eb.png";